<!-- Alert -->
<fuse-alert
    class="mt-8"
    *ngIf="showAlert"
    [appearance]="'outline'"
    [showIcon]="false"
    [type]="alert.type"
    [@shake]="alert.type === 'error'">
    {{alert.message}}
</fuse-alert>

<mat-dialog-content class="p-0 m-0 overflow-scroll">
    <form [formGroup]="cancellationForm" class="ml-1" *ngIf="!cancelled">
        <h1 class="text-xl md:text-2xl font-bold mb-4">Package Cancellation</h1>
        <p class="font-bold text-md mb-6">
            We're sorry to hear you're considering canceling your service. Before we proceed, is there anything we
            can do to improve your experience or address any concerns you might have?
        </p>
        <mat-form-field class="w-full rounded-2xl z-9999" >
            <mat-label class="font-bold">Suggested Improvements:</mat-label>
            <textarea id="name" class="text-xl" [formControlName]="'suggestedImprovements'" matInput></textarea>
        </mat-form-field>

        <mat-form-field class="w-full rounded-2xl z-9999">
            <mat-label class="font-bold">Select cancellation date:</mat-label>
            <input matInput  [formControlName]="'date'" [min]="minDate" [max]="maxDate" [matDatepicker]="picker" placeholder="Choose a date">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>

        <mat-form-field class="w-full rounded-2xl z-9999">
            <mat-label class="font-bold">Reason for cancellation:</mat-label>
            <mat-select matNativeControl [formControlName]="'reason'" (selectionChange)="resonChanged($event)">
              <mat-option *ngFor="let reason of cancellationReasonsList" [value]="reason">
                {{reason?.Description}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field class="w-full rounded-2xl z-9999" *ngIf="requiresAdditionalInformation">
            <mat-label class="font-bold">Additional Information:</mat-label>
            <textarea id="name" class="text-xl" [formControlName]="'additionalInformation'" matInput></textarea>
        </mat-form-field>

          <div class="flex flex-row justify-end">
            <button class="mt-2 text-lg font-bold mx-4 bg-gray-100" mat-flat-button (click)="closeDialog()">
                Close
            </button>
            <button class="mt-2 text-lg font-bold mx-4 bg-accent" mat-flat-button (click)="cancelService()" [disabled]="!cancellationForm.valid">
                Proceed
            </button>
        </div>
    </form> 
    <div *ngIf="cancelled" class="flex flex-col items-center">
        <div class="self-start">
            <h1 class="text-xl md:text-2xl font-bold mb-4">Package Cancellation</h1>
            <p class="font-bold text-md mb-6">
              We have received your cancellation request for lead: <b>{{data?.OrderReferenceNumber}}</b>, and will be processed according to our cancellation policy.
            </p>
        </div>
        <button class="mt-2 text-lg font-bold mx-4 bg-accent w-1/3" mat-flat-button (click)="closeCancelServiceConfirmationDialog()">
            Done
        </button>
    </div>
</mat-dialog-content>